<div class="container-pendiente" style="padding: 1rem" *ngIf="orderLoaded | async">
  <app-alert></app-alert>

  <div class="header-title" *ngIf="Paso2">
    <label class="style-label-title">
      {{ presentation.referenceLabel }}:<span class="style-span-title">
        {{ order.orderNumber }}
      </span>
    </label>
  </div>

  <div class="Paso1 step-right" *ngIf="Paso1 || Paso2">
    <app-pedidos-pendiente-observaciones
      [order]="order"
      (nextStep)="toStep3()"
      (rejectTruck)="toRejection()">
    </app-pedidos-pendiente-observaciones>

    <ng-template #contenidoModal>
      <div>
        <div class="header-container-modal">
          <label></label>
          <button mat-icon-button class="close-icon" (click)="onCierrenModal()">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>

        <div style="text-align: center">
          <i class="bi bi-exclamation-triangle-fill modal-warning-icon"></i>
          <h6 class="text-title-modal">¿Deseas confirmar los datos?</h6>
          <p class="text-descripcion-modal">
            Una vez confirmados no será posible cambiar la información.
          </p>
        </div>
        <div class="row size-button">
          <div class="col-6">
            <button type="button" class="btn btn-primary-update">Editar</button>
          </div>
          <div class="col-6">
            <button type="button" class="btn btn-primary" (click)="confirmarObservacion()">
              Guardar
            </button>
          </div>
        </div>
      </div>
    </ng-template>
  </div>

  <div class="step-right" *ngIf="!Paso1 || !Paso2" [ngClass]="{ 'reject-container': Paso5 }">
    <div class="Paso3 qr" *ngIf="Paso3">
      <app-pedidos-pendiente-qr
        [order]="order"
        (toNextStep)="toStep4()">
      </app-pedidos-pendiente-qr>
    </div>

    <div class="Paso4 Firma" *ngIf="Paso4">
      <app-pedidos-pendiente-firma [order]="order"></app-pedidos-pendiente-firma>
    </div>
  </div>
</div>
